export default __webpack_public_path__ + "static/media/FAVICON_18.0a106768.png";